import themeGet from '@pyt/ui/utils/themeGet'
import styled, { css } from 'styled-components'

// PAX LINE LAYOVER STYLES STARTS
export const Layover = styled.div`
	position: relative;
	text-align: center;
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	margin: ${props => props.layoverMargin || '32px -20px 0'};

	&:before {
		content: '';
		width: 100%;
		display: block;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
		position: absolute;
		top: 50%;
		z-index: 1;
	}
`

export const LayoverLink = styled.span`
	color: #148099;
	font-weight: 600;
	font-size: 13px;
	line-height: 16px;
	letter-spacing: -0.231818px;
	background-color: ${themeGet('colors.white')};
	max-width: 80%;
	position: relative;
	display: flex;
	align-items: center;
	z-index: 1;
	padding: 0 8px;
	cursor: pointer;
	${props =>
		props.showBorder &&
		css`
			border: 1px solid #e5e5e5;
			border-radius: 24px;
			font-size: 15px;
			line-height: 24px;
			padding: 4px 12px;
		`};
	${props =>
		css`
			color: ${props.textColor};
		`};

	${props =>
		props.disable &&
		css`
			cursor: not-allowed;
			color: ${props =>
				props.delete ? 'rgba(241, 95, 117, 0.3)' : 'rgba(20, 128, 153, 0.3)'};
		`};

	${props =>
		props.hide &&
		css`
			display: none;
		`};

	i {
		font-size: ${props => (props.showBorder ? '22px' : '16px')};
		vertical-align: text-top;
		margin-right: 3px;
	}
`
// PAX LINE LAYOVER STYLES ENDS

export const LinkLayover = ({
	links = [
		{
			text: 'Linker',
			iconClassName: 'pyt-plus-16',
			onClickAction: () => {},
			isDisabled: false,
			isHide: false,
			textColor: '#148099',
		},
	],
	layoverMargin = '',
}) => {
	return (
		<Layover layoverMargin={layoverMargin}>
			{links.map((link, linkIndex) => {
				return (
					<LayoverLink
						key={linkIndex}
						onClick={link.isDisabled ? () => {} : link.onClickAction}
						textColor={link.textColor}
						disable={link.isDisabled}
						hide={link.isHide}
						showBorder={link.showBorder || false}
					>
						<i className={link.iconClassName} />
						{link.text}
					</LayoverLink>
				)
			})}
		</Layover>
	)
}
